import React, { useState, useEffect } from "react";

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import drdeshpandemaneesha from "./Img/user/drmaneesha.webp";
import drAbhijeetDeshmukh from "./Img/user/drAbhijeet.webp";
import norcood from "./Img/user/norcood.webp";
import jayaphysio from "./Img/user/jayaphysio.webp";
import aquacentric from "./Img/user/aquacentric.webp";

// Data for users
const Data = [
  {
    items: [
     
      {
        image: norcood,
        name: ["Dr. Neeta Modak", "Dr. Vaishali Dahake"],
        role: "Directors NARCAOOD,Nagpur",
      },
      {
        image: drdeshpandemaneesha,
        name: "Dr. Maneesha Deshpande",
        role: "Principal VSPM College of Physiotherapy",
      },
      {
        image: drAbhijeetDeshmukh,
        name: "Dr. Abhijeet Deshmukh",
        role: "Prof. and Director AD's Fitness World & Anupam Physiotherapy Clinic",
      },
      {
        image: jayaphysio,
        name: "Jaya Physio",
        role: "Hyderabad",
      },
      {
        image: aquacentric,
        name: "Aquacentric Therapy",
        role: "Mumbai",
      },
     
    ],
  },
];


function User() {
  const [isLargeScreen, setIsLargeScreen] = useState(() =>
            window.matchMedia("(min-width: 1280px)").matches
          );
           useEffect(() => {
              const mediaQuery = window.matchMedia("(min-width: 1280px)");
              const handleChange = (e) => setIsLargeScreen(e.matches);
              mediaQuery.addEventListener("change", handleChange);
          
              return () => {
                mediaQuery.removeEventListener("change", handleChange);
              };
            }, []);
  const settings = {
    infinite: true,
    speed: 3000,
    slidesToShow: 3, // Default: 3 slides
    slidesToScroll: 1,
    autoplay: true,
    centerMode: true,
    autoplaySpeed: 5000,
    responsive: [
      {
        breakpoint: 1280, // For screens less than 350px
        settings: {
          slidesToShow: 1, 
          slidesToScroll: 1,
          centerMode: true, // Disable centering for better layout on small screens
          centerPadding: "20px",
        },
      },
    ],
  };

   const slideStyle = {
     paddingRight: "calc(var(--unit) * 10) !important",  //Add horizontal padding for spacing between slides
     paddingLeft: "calc(var(--unit) * 10) !important",
   };

  return (
  <> 
  {isLargeScreen&&
    <div className="d-flex flex-column uw-315 bg-gray-light justify-content-center m-0 upy-3"
    style={{
      overflow:"hidden",
    }}>
      <div className="bg-dark-blue text-white upy-3 m-0">
        <p className="text-center fw-bold ufs-7 m-0 ">OUR RENOWNED USERS</p>
      </div>
      <div className=" m-0 p-0">
      <Slider {...settings} pauseOnHover={false} pauseOnDotsHover={false} pauseOnFocus={false}>
        {Data[0].items.map(({ image, name, role }, index) => (
          <div key={index} style={{slideStyle} } >
            <div className="position-relative d-flex flex-column box-shadow bg-gray-light umy-5 p-0  br-5 uh-144 uw-80">
              {/* Image */}
              <div
                className="image-container uh-80 uw-80"
                style={{
                  backgroundImage: `url(${image})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  borderTopRightRadius: "calc(var(--unit) * 5) !important",
                  borderTopLeftRadius: "calc(var(--unit) * 5) !important",
                }}
              ></div>
              {/* Text below the image */}
              <div
                className="d-flex flex-column text-center justify-content-center align-items-center bg-gray-light"
                style={{
                  height: "30%",
                }}
              >
                {/* Render names */}
                {Array.isArray(name) ? (
                  name.map((n, i) => (
                    <p key={i} className="m-0 upx-2 upy-1 ufs-6 text-blue fw-bold">
                      {n}
                    </p>
                  ))
                ) : (
                  <p className="m-0 upx-2 upy-1 ufs-6 text-blue fw-bold">{name}</p>
                )}
                <p className="m-0 uyp-1 ufs-4 fw-bold">{role}</p>
              </div>
            </div>
          </div>
        ))}
      </Slider>
      </div>
    </div>
  }{!isLargeScreen&&
    <div className="d-flex flex-column w-100 bg-gray-light justify-content-center m-0 upy-3"
    style={{
      overflow:"hidden",
    }}>
      <div className="bg-dark-blue text-white upy-3 m-0">
        <p className="text-center fw-bold ufs-14 m-0 ">OUR RENOWNED USERS</p>
      </div>
      <div className=" m-0 p-0">
      <Slider {...settings} pauseOnHover={false} pauseOnDotsHover={false} pauseOnFocus={false}>
        {Data[0].items.map(({ image, name, role }, index) => (
          <div key={index} style={{slideStyle} }  >
            <div className="position-relative d-flex flex-column box-shadow bg-gray-light umy-5 p-0  br-20 w-75"
           >
              {/* Image */}
              <div
                className="image-container uh-250 w-100"
                style={{
                  backgroundImage: `url(${image})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  borderTopRightRadius: "calc(var(--unit) * 20) !important",
                  borderTopLeftRadius: "calc(var(--unit) * 20) !important",
                }}
              ></div>
              {/* Text below the image */}
              <div
                className="d-flex flex-column text-center justify-content-center px-2 uh-100 align-items-center bg-gray-light br-20"
                style={{
                  height: "30%",
                }}
              >
                {/* Render names */}
                {Array.isArray(name) ? (
                  name.map((n, i) => (
                    <p key={i} className="m-0 p-0 upy-1 ufs-14 text-blue fw-bold">
                      {n}
                    </p>
                  ))
                ) : (
                  <p className="m-0 p-0 ufs-14 text-blue fw-bold">{name}</p>
                )}
                <p className="m-0 uyp-1 ufs-12 fw-bold">{role}</p>
              </div>
            </div>
          </div>
        ))}
      </Slider>
      </div>
    </div>
  
  } 
  
  </>
    
  );
}

export default User;
